import { useQuery } from "@tanstack/react-query";
import {
	type ImportJobStatus,
	ImportJobStatus as ImportJobStatusEnum,
	getApiCodelistManagementImportJobs,
} from "Infrastructure/Api/Api";

export const IMPORT_JOBS_QUERY_KEY = "IMPORT_JOBS_QUERY";

export function useImportJobsQuery(
	localization?: string | null,
	status?: ImportJobStatus | null,
	offset?: number | null,
	limit?: number | null,
	refetchInterval?: number | false,
) {
	return useQuery({
		queryKey: [IMPORT_JOBS_QUERY_KEY, localization, status, offset, limit],
		queryFn: () =>
			getApiCodelistManagementImportJobs(
				localization,
				status,
				offset ?? undefined,
				limit ?? undefined,
			),
		refetchInterval,
	});
}

export function useRunningImportJobQuery() {
	const query = useQuery({
		queryKey: [IMPORT_JOBS_QUERY_KEY, "running"],
		queryFn: () =>
			getApiCodelistManagementImportJobs(
				null,
				ImportJobStatusEnum.Running,
				0,
				1,
			),
		refetchInterval: 3000,
	});

	const runningJob =
		query.data?.status === 200 && query.data.data.items.length > 0
			? query.data.data.items[0]
			: null;

	return {
		...query,
		runningJob,
		isRunning: !!runningJob,
	};
}
